"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extend = exports.freezeObjectField = exports.sleep = exports.defaultCloneResponse = exports.REQUEST_CACHE = exports.defaultCacheKey = exports.getUri = exports.callWithMiddlewares = exports.extractRequestConfig = exports.mergeRequestConfig = exports.mergeGlobalConfig = exports.mergeCacheConfig = void 0;
const mergeConfig_js_1 = __importDefault(require("axios/lib/core/mergeConfig.js"));
const axios_1 = __importDefault(require("axios"));
exports.mergeCacheConfig = (cache1, cache2) => {
    if (cache1 === undefined) {
        return cache2;
    }
    if (cache2 === undefined) {
        return cache1;
    }
    if (typeof cache1 === 'boolean') {
        return cache2;
    }
    if (typeof cache2 === 'boolean') {
        return cache2 ? cache1 : false;
    }
    return Object.assign(Object.assign({}, cache1), cache2);
};
function extendMergeConfig(config, config2merge) {
    const axiosMerged = mergeConfig_js_1.default(config, config2merge);
    const merged = Object.assign(Object.assign(Object.assign({}, config), config2merge), axiosMerged);
    const cachedMerged = exports.mergeCacheConfig(config === null || config === void 0 ? void 0 : config.cache, config2merge === null || config2merge === void 0 ? void 0 : config2merge.cache);
    if (cachedMerged !== undefined) {
        merged.cache = cachedMerged;
    }
    // axios在0.21版本后其他配置改成了deepMerge并生成了新的对象，在这里保持和原来的处理一致，取最新那个即可。
    const directKeys = ['ref', 'debounceContext'];
    directKeys.forEach(function (key) {
        if (config2merge === null || config2merge === void 0 ? void 0 : config2merge[key]) {
            merged[key] = config2merge[key];
        }
    });
    return merged;
}
function mergeGlobalConfig(config, config2merge) {
    return extendMergeConfig(config, config2merge);
}
exports.mergeGlobalConfig = mergeGlobalConfig;
function mergeRequestConfig(config, config2merge) {
    return extendMergeConfig(config, config2merge);
}
exports.mergeRequestConfig = mergeRequestConfig;
function extractRequestConfig(globalConfig) {
    return globalConfig;
}
exports.extractRequestConfig = extractRequestConfig;
async function callWithMiddlewares(context, middlewares, instance) {
    async function dispatch(index) {
        var _a;
        const middleware = (_a = middlewares[index]) === null || _a === void 0 ? void 0 : _a.bind(instance);
        if (!middleware) {
            return;
        }
        let nextHasBeenCalled = false;
        const next = async () => {
            if (nextHasBeenCalled) {
                throw Error("You can't call `next` multiple times in a middleware.");
            }
            nextHasBeenCalled = true;
            await dispatch(index + 1);
        };
        await middleware(context, next);
    }
    await dispatch(0);
}
exports.callWithMiddlewares = callWithMiddlewares;
function getUri(config) {
    return axios_1.default.getUri(config);
}
exports.getUri = getUri;
function defaultCacheKey(config) {
    if (config.method &&
        config.method.toUpperCase() === 'GET' &&
        (config.responseType === 'text' || config.responseType === 'json')) {
        return getUri(config);
    }
    return null;
}
exports.defaultCacheKey = defaultCacheKey;
exports.REQUEST_CACHE = new Map();
exports.defaultCloneResponse = (response) => JSON.parse(JSON.stringify(response));
exports.sleep = async (timeout) => await new Promise(r => setTimeout(r, timeout));
exports.freezeObjectField = (obj, field) => Object.defineProperty(obj, field, {
    configurable: false,
    writable: false,
});
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
// eslint-disable-next-line
function extend(a, b, thisArg, excludes) {
    let keys = Object.keys(b);
    keys = excludes ? keys.filter(key => !excludes.includes(key)) : keys;
    keys.forEach(key => {
        const val = b[key];
        if (thisArg && typeof val === 'function') {
            a[key] = val.bind(thisArg);
        }
        else {
            a[key] = val;
        }
    });
    return a;
}
exports.extend = extend;
//# sourceMappingURL=utils.js.map